import { section } from '@/glow';
import { focusFormStatus } from '@/lib/a11y';
import { AnimateNewsletter } from '@/lib/animation';

section('newsletter', {
  onLoad() {
    focusFormStatus(this.container);
    this.AnimateNewsletter = AnimateNewsletter(this.container);
  },
  onUnload() {
    this.AnimateNewsletter?.destroy();
  },
});
